import type { FC } from "react";

import { useSelector } from "react-redux";

import type { IPlainTooltipProps } from "@similarweb/ui-components";

import type { TableActionProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { WEBSITE_ASSIGN_TO_USER_MODAL_TITLE } from "app/pages/sales-intelligence/modules/leads-search";

import AssignToUserModal from "../../../../assign-to-users/components/AssignToUserModal/AssignToUserModal";
import AssignToOtherUsersButtonBaseContainer from "../../../../assign-to-users/containers/AssignToOtherUsersButton/AssignToOtherUsersButtonBaseContainer";
import { selectIsShowAssignToUserModal } from "../../../../assign-to-users/store/selectors";

type AssignToUserCompetitiveButtonContainerProps = {
    onClick: () => void;
    tooltipContent?: IPlainTooltipProps["tooltipContent"];
} & TableActionProps;

const AssignToUserCompetitiveButtonContainer: FC<AssignToUserCompetitiveButtonContainerProps> = ({
    isDisabled = false,
    tooltipContent,
    onClick,
}) => {
    const isShowAssignToUserModal = useSelector(selectIsShowAssignToUserModal);

    return (
        <>
            <AssignToUserModal
                isOpen={isShowAssignToUserModal}
                titleTranslatable={WEBSITE_ASSIGN_TO_USER_MODAL_TITLE}
            />
            <AssignToOtherUsersButtonBaseContainer
                isDisabled={isDisabled}
                tooltipContent={tooltipContent}
                onClick={onClick}
            />
        </>
    );
};

export default AssignToUserCompetitiveButtonContainer;
